import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SUPPORTED_LANGUAGES = ['en', 'lv', 'lt', 'ee'];
const BASE_URL = 'https://0gbaltics.com';

export const HreflangTags = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <Helmet>
      {/* Default language (English) */}
      <link rel="alternate" hrefLang="x-default" href={`${BASE_URL}${currentPath}`} />
      
      {/* All supported languages */}
      {SUPPORTED_LANGUAGES.map((lang) => (
        <link
          key={lang}
          rel="alternate"
          hrefLang={lang === 'ee' ? 'et' : lang}
          href={`${BASE_URL}${currentPath}?lang=${lang}`}
        />
      ))}
    </Helmet>
  );
};

export default HreflangTags;
